import { render, staticRenderFns } from "./validation-messages-dialog.vue?vue&type=template&id=bc0dd620&scoped=true&lang=pug&"
import script from "./validation-messages-dialog.vue?vue&type=script&lang=ts&"
export * from "./validation-messages-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./validation-messages-dialog.vue?vue&type=style&index=0&id=bc0dd620&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc0dd620",
  null
  
)

export default component.exports